export default __webpack_public_path__ + "static/media/package-bg.cc38deea.jpg";